<template lang="pug">
  nav.main-header.navbar.navbar-expand.navbar-light.border-bottom
    // Left navbar links
    //ul.navbar-nav
      li.nav-item
        a.nav-link(data-widget='pushmenu')
          i.fa.fa-bars
    ol.breadcrumb.float-sm-right
      li.breadcrumb-item.active Solicitud de Información
    // Right navbar links
    ul.navbar-nav.ml-auto
      // User Dropdown Menu
      li.nav-item.dropdown
        a.nav-link(data-toggle='dropdown')
          i.fa.fa-user-o
        .dropdown-menu.dropdown-menu-lg.dropdown-menu-right
          a.dropdown-item(@click="logout()")
            i.fa.fa-sign-out.mr-2
            |  Salir del sistema
</template>

<script>
import CAS from '../CAS-client'

export default {
  props: [ 'username' ],
  methods: {
    logout: function () {
      CAS.logout();
      // this.$emit('logout', event.detail)
    }
  }
}
</script>
